import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Tab,
  Tabs,
} from "@mui/material";
import "./SessionsDetail.scss";
import { API_RESPONSE, NUMBER_CONSTANTS, SESSION_STATUS, STORAGE_KEYS } from "../../../../Utilities/Constants/Constants";
import { useEffect, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate, useParams } from "react-router-dom";
import { axiosInstance } from "../../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../../Utilities/Constants/ApiEndpoints";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import moment from 'moment'

const SessionsDetail = () => {
  const [tabValue, setTabValue] = useState(SESSION_STATUS.UPCOMING);
  const { id } = useParams();
  const navigate = useNavigate();
  const [ sessionDetail, setSessionDetail]:any= useState();
  const [ sessions, setSessions]:any= useState();
  const [ upcomingSessions, setUpcomingSessions ] = useState();
  /**Update tab value */
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  };

  useEffect(()=>{
    getSessionDetail()
  },[]);

  /* Formatting time */
  const formatDate= (time:any)=>{
    return moment(time, 'HH:mm').format('h:mm A');
 }

 /* Getting session detail API */
  const getSessionDetail = ()=>{
      axiosInstance.get(API_END_POINTS.SESSIONS_LIST + `?${STORAGE_KEYS.ID}=` + id).then(response=>{
        if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
          setSessionDetail(response.data.result.data.data[NUMBER_CONSTANTS.ZERO])
          setUpcomingSessions(response.data.result.data.data[NUMBER_CONSTANTS.ZERO].slots);
          setSessions(response.data.result.data);
        }
      })
  }

  return (
    <>
      <div className="session_slot_details_container">
        <div className="arrow-button-wrapper">
          <div className="d-flex">
          <ArrowBackIcon onClick={()=>{navigate(-1)}}/><h5>Session Detail</h5>
          </div>
           
           <button className="btn edit-btn" onClick={()=>{
            navigate(`/manage-sessions/edit/${sessionDetail?.id}`);
           }}>Edit Session</button>
        </div>
        <div className="session_details_wrapper">
        <div className="row row-wrapper">
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                   <div className="session_label">Course</div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <div className="session_value">{sessionDetail?.category_name}</div>
                </div>
              </div>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8">
               
                
                <div className="slot_counts_label">Number of Slot</div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                <div className="slot_counts">{sessionDetail?.slot_count}</div>
                </div>
              </div>
          </div>
        </div>
        <div className="row row-wrapper">
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
             <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div className="session_label">Topic</div>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div className="session_value">{sessionDetail?.session_title} </div>
              </div>
             </div>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 row-wrapper">
              <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8">
               
                <div className="slot_counts_label">Balance</div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                <div className="slot_counts">00</div>
                </div>
              </div>
          </div>
        </div>
        <div className="row row-wrapper">
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
             <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div className="session_label">Location</div>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div className="session_value">Chennai</div>
              </div>
             </div>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8">
                
                <div className="slot_counts_label">Completed</div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                <div className="slot_counts">08</div>
                </div>
              </div>
          </div>
        </div>
        <div className="row row-wrapper">
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
             <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div className="session_label">Session ID</div>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div className="session_value">{sessionDetail?.id}</div>
              </div>
             </div>
          </div>

        </div>
        
        </div>

        <Box sx={{ width: "100%" }}>
          <Tabs
            value={tabValue}
            onChange={handleChange}
            textColor="secondary"
            indicatorColor="secondary"
            aria-label="secondary tabs example"
            className="header_tabs"
          >
            <Tab
              value={SESSION_STATUS.UPCOMING}
              label={SESSION_STATUS.UPCOMING}
            />
             <Tab
              value={SESSION_STATUS.ONGOING}
              label={SESSION_STATUS.ONGOING}
            />
            <Tab
              value={SESSION_STATUS.COMPLETED}
              label={SESSION_STATUS.COMPLETED}
            />
           
          </Tabs>
        </Box>
        <div className="slot_details_wrapper">
         {tabValue=== SESSION_STATUS.UPCOMING && sessions?.upcoming?.map((slot:any)=>{
          return(
            <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <div className="slot_date_time_wrapper">
                <div className="slot_date">{slot.start_date}</div>
                <div className="slot_time_head">{formatDate(slot.start_time)}</div>
                {/* <div className="slot_time">12:00 PM</div>
                <div className="slot_time">12:00 PM</div> */}
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <div className="slot_card_container">
              <div className="slot_course">{sessionDetail.session_title}</div>
              <div className="slot_curriculum">{sessionDetail.category_name}</div>
                <div className="slot_time_date">{slot.start_date}</div>
                <div className="slot_time">{formatDate(slot.start_time)}-{formatDate(slot.end_time)}</div>
               
               
                <div className="slot_mode_group">
                  <div className="slot_mode">{sessionDetail.course_type===NUMBER_CONSTANTS.ONE ? "Online":"On-premises"}</div>
                  {/* <div className="slot_mode">Individual</div> */}
                </div>
               {/*  <div className="slot_group_count">
                  <div className="slot_group_notation"></div>
                  <div className="students_count">Student name</div>
                </div> */}
              </div>
            </AccordionDetails>
            </Accordion>
          )
           
         })}

         {tabValue=== SESSION_STATUS.ONGOING && sessions?.ongoing?.map((slot:any)=>{
          return(
            <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <div className="slot_date_time_wrapper">
                <div className="slot_date">{slot.start_date}</div>
                <div className="slot_time_head">{slot.start_time}</div>
                {/* <div className="slot_time">12:00 PM</div>
                <div className="slot_time">12:00 PM</div> */}
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <div className="slot_card_container">
              <div className="slot_course">{sessionDetail.session_title}</div>
              <div className="slot_curriculum">{sessionDetail.category_name}</div>
                <div className="slot_time_date">Slot Date: {slot.start_date}</div>
                <div className="slot_time">Slot Time:{slot.start_time}-{slot.end_time}</div>
               
               
                <div className="slot_mode_group">
                  <div className="slot_mode">{sessionDetail.course_type===NUMBER_CONSTANTS.ONE ? "Online":"On-premises"}</div>
                  {/* <div className="slot_mode">Individual</div> */}
                </div>
               {/*  <div className="slot_group_count">
                  <div className="slot_group_notation"></div>
                  <div className="students_count">Student name</div>
                </div> */}
              </div>
            </AccordionDetails>
            </Accordion>
          )
           
         })}
                  {tabValue=== SESSION_STATUS.COMPLETED && sessions?.completed?.map((slot:any)=>{
          return(
            <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <div className="slot_date_time_wrapper">
                <div className="slot_date">{slot.start_date}</div>
                <div className="slot_time_head">{slot.start_time}</div>
                {/* <div className="slot_time">12:00 PM</div>
                <div className="slot_time">12:00 PM</div> */}
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <div className="slot_card_container">
              <div className="slot_course">{sessionDetail.session_title}</div>
              <div className="slot_curriculum">{sessionDetail.category_name}</div>
                <div className="slot_time_date">Slot Date: {slot.start_date}</div>
                <div className="slot_time">Slot Time:{slot.start_time}-{slot.end_time}</div>
               
               
                <div className="slot_mode_group">
                  <div className="slot_mode">{sessionDetail.course_type===NUMBER_CONSTANTS.ONE ? "Online":"On-premises"}</div>
                  {/* <div className="slot_mode">Individual</div> */}
                </div>
               {/*  <div className="slot_group_count">
                  <div className="slot_group_notation"></div>
                  <div className="students_count">Student name</div>
                </div> */}
              </div>
            </AccordionDetails> 
            </Accordion>
          )
           
         })}
        
        </div>
      </div>
    </>
  );
};

export default SessionsDetail;
